
import { useEffect, useState } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";
import DadosSistemaService from "../../services/DadosSistemaService";

export default function FormDadosSistema({ itemSelecionado, modo, onClose }) {
  const { setRetorno } = useGerenciamento();

  const initialState = {
    id: null,
    tipoPessoa: "PF",
    nomeResponsavel: "",
    nomeFantasia: "",
    razaoSocial: "",
    cpfCnpj: "",
    inscricaoEstadual: "",
    inscricaoMunicipal: "",
    email1: "",
    email2: "",
    telefone1: "",
    telefone2: "",
    telefone3: "",
    site: "",
    rua: "",
    numero: "",
    bairro: "",
    complemento: "",
    cep: "",
    cidade: "",
    uf: "",
    smtpHost: "",
    smtpPort: "",
    smtpUsername: "",
    smtpPassword: "",
    smtpProtocol: "",
    smtpAuth: true,
    smtpStarttls: true,
    emailRemetente: "",
    nomeRemetente: "",
    ativo: true,
    configurado: false,
  };

  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);

  useEffect(() => {
    if (modo === "novo") {
      setForm(initialState);
      setErrors({});
      return;
    }

    
    if (modo === "alterar" && itemSelecionado) {

      setForm({

        id: itemSelecionado.ID,

        tipoPessoa: itemSelecionado.TIPO_PESSOA ?? "",
        nomeResponsavel: itemSelecionado.NOME_RESPONSAVEL?? "",
        nomeFantasia: itemSelecionado.NOME_FANTASIA ?? "",
        razaoSocial: itemSelecionado.RAZAO_SOCIAL ?? "",
        cpfCnpj: itemSelecionado.CPF_CNPJ ?? "",
        inscricaoEstadual: itemSelecionado.INSCRICAO_ESTADUAL ?? "",
        inscricaoMunicipal: itemSelecionado.INSCRICAO_MUNICIPAL ?? "",
        email1: itemSelecionado.EMAIL1 ?? "",
        email2: itemSelecionado.EMAIL2 ?? "",
        telefone1: itemSelecionado.TELEFONE1 ?? "",
        telefone2: itemSelecionado.TELEFONE2 ?? "",
        telefone3: itemSelecionado.TELEFONE3 ?? "",
        site: itemSelecionado.SITE ?? "",
        rua: itemSelecionado.RUA ?? "",
        numero: itemSelecionado.NUMERO ?? "",
        bairro: itemSelecionado.BAIRRO ?? "",
        complemento: itemSelecionado.COMPLEMENTO ?? "",
        cep: itemSelecionado.CEP ?? "",
        cidade: itemSelecionado.CIDADE ?? "",
        uf: itemSelecionado.UF ?? "",

        smtpHost: itemSelecionado.SMTP_HOST ?? "",
        smtpPort: itemSelecionado.SMTP_PORT ?? "",
        smtpUsername: itemSelecionado.SMTP_USERNAME ?? "",
        smtpPassword: itemSelecionado.SMTP_PASSWORD ?? "",
        smtpProtocol: itemSelecionado.SMTP_PROTOCOL ?? "",
        smtpAuth: Boolean(itemSelecionado.SMTP_AUTH) ?? "",
        smtpStarttls: Boolean(itemSelecionado.SMTP_STARTTLS) ?? "",

        emailRemetente: itemSelecionado.EMAIL_REMETENTE ?? "",
        nomeRemetente: itemSelecionado.NOME_REMETENTE ?? "",

        ativo: Boolean(itemSelecionado.ATIVO) ?? "",
        configurado: Boolean(itemSelecionado.CONFIGURADO) ?? ""

      });

      setErrors({});
    }

  }, [modo, itemSelecionado]);

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: checked }));
      return;
    }
    if (name === "ativo" || name === "configurado") {
      setForm((prev) => ({ ...prev, [name]: value === "true" }));
      return;
    }
    setForm((prev) => ({ ...prev, [name]: value }));
  }


 
  // == Consulta CEP (ViaCEP) ====================================
  async function buscarCep() {
    const cepLimpo = form.cep.replace(/\D/g, "");

    if (cepLimpo.length !== 8) {
      alert("CEP inválido. Digite 8 números.");
      setRetorno({ tipo: "erro", mensagem: "CEP inválido. Digite 8 números." });
      return;
    }

    try {
      setBuscandoCep(true);

      const resposta = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (!resposta.ok) {
        alert("Erro ao consultar o CEP.");
        setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
        return;
      }

      const dados = await resposta.json();

      if (dados.erro) {
        alert("CEP não encontrado.");
        setRetorno({ tipo: "erro", mensagem: "CEP não encontrado." });
        return;
      }

      setForm((prev) => ({
        ...prev,
        rua: dados.logradouro || "",
        bairro: dados.bairro || "",
        cidade: dados.localidade || "",
        uf: dados.uf || "",
      }));

    } catch (error) {
      setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
      console.error(error);
    } finally {
      setBuscandoCep(false);
    }
  }

  // == Validação ====================================
  function validarEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || ""));
  }

  function validarCpfCnpj(valor) {
    const d = String(valor || "").replace(/\D/g, "");
    return d.length === 11 || d.length === 14;
  }

  function validarCampos() {
    const e = {};
    if (!form.tipoPessoa) e.tipoPessoa = "Informe o tipo";
    if (!form.nomeResponsavel) e.nomeResponsavel = "Informe o responsável";
    if (!form.cpfCnpj) e.cpfCnpj = "Informe o CPF/CNPJ";
    else if (!validarCpfCnpj(form.cpfCnpj)) e.cpfCnpj = "CPF(11) ou CNPJ(14) dígitos";
    if (!form.email1) e.email1 = "Informe o e-mail";
    else if (!validarEmail(form.email1)) e.email1 = "E-mail inválido";
    if (form.email2 && !validarEmail(form.email2)) e.email2 = "E-mail inválido";
    if (!form.telefone1) e.telefone1 = "Informe o telefone";
    if (form.uf && String(form.uf).length !== 2) e.uf = "UF 2 letras";
    if (form.smtpPort !== "" && isNaN(Number(form.smtpPort))) e.smtpPort = "Porta numérica";

    if (form.tipoPessoa === "PJ" && !form.razaoSocial) e.razaoSocial = "Informe a razão social";
    return e;
  }

  function Payload_form(data) {

    return {

      TIPO_PESSOA: data.tipoPessoa,
      NOME_RESPONSAVEL: data.nomeResponsavel,
      NOME_FANTASIA: data.nomeFantasia || null,
      RAZAO_SOCIAL: data.razaoSocial || null,
      CPF_CNPJ: data.cpfCnpj,
      INSCRICAO_ESTADUAL: data.inscricaoEstadual || null,
      INSCRICAO_MUNICIPAL: data.inscricaoMunicipal || null,
      EMAIL1: data.email1,
      EMAIL2: data.email2 || null,
      TELEFONE1: data.telefone1,
      TELEFONE2: data.telefone2 || null,
      TELEFONE3: data.telefone3 || null,
      SITE: data.site || null,
      RUA: data.rua || null,
      NUMERO: data.numero === "" || data.numero == null ? null : Number(data.numero),
      BAIRRO: data.bairro || null,
      COMPLEMENTO: data.complemento || null,
      CEP: data.cep || null,
      CIDADE: data.cidade || null,
      UF: data.uf ? data.uf.trim().toUpperCase() : null,

      SMTP_HOST: data.smtpHost || null,
      SMTP_PORT: data.smtpPort === "" || data.smtpPort == null ? null : Number(data.smtpPort),
      SMTP_USERNAME: data.smtpUsername || null,
      SMTP_PASSWORD: data.smtpPassword || null,
      SMTP_PROTOCOL: data.smtpProtocol || null,
      SMTP_AUTH: Boolean(data.smtpAuth),
      SMTP_STARTTLS: Boolean(data.smtpStarttls),

      EMAIL_REMETENTE: data.emailRemetente || null,
      NOME_REMETENTE: data.nomeRemetente || null,

      ATIVO: Boolean(data.ativo),
      CONFIGURADO: Boolean(data.configurado),

      CRIADO_POR: null,
      ATUALIZADO_POR: null

    };

  }

  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

      const payload = Payload_form(form);

      if (modo === "novo") {

        try{
            await DadosSistemaService.create(payload);
            setRetorno({ tipo: "sucesso", mensagem: "Dados do sistema criados com sucesso!" });
            onClose?.();

          } catch (error) {

            setRetorno({
              tipo: "erro",
              mensagem: modo === "novo" ? "Erro ao criar dados do sistema." : "Erro ao atualizar dados do sistema.",
            });
            console.error(error);
            onClose?.();

          } finally {
            setLoading(false);
          }
      }

      if (modo === "alterar") {
        
        try{

          await DadosSistemaService.update(form.id, payload);
          setRetorno({ tipo: "sucesso", mensagem: "Dados do sistema atualizados com sucesso!" });
          onClose?.();

        } catch (error) {
        
          setRetorno({
          tipo: "erro",
            mensagem: modo === "novo" ? "Erro ao criar dados do sistema." : "Erro ao atualizar dados do sistema.",
          });
          console.error(error);
          onClose?.();

        } finally {
          setLoading(false);
        }
      }
  }

  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          {modo === "novo" ? "Dados do Sistema" : "Alterar Dados do Sistema"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Tipo Pessoa: *</div>
          <select name="tipoPessoa" value={form.tipoPessoa} onChange={handleChange}>
            <option value="PF">PF</option>
            <option value="PJ">PJ</option>
          </select>
          {errors.tipoPessoa && <span style={{ color: "red" }}>{errors.tipoPessoa}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome Responsável: *</div>
          <input name="nomeResponsavel" value={form.nomeResponsavel} onChange={handleChange} />
          {errors.nomeResponsavel && <span style={{ color: "red" }}>{errors.nomeResponsavel}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome Fantasia:</div>
          <input name="nomeFantasia" value={form.nomeFantasia} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Razão Social:</div>
          <input name="razaoSocial" value={form.razaoSocial} onChange={handleChange} />
          {errors.razaoSocial && <span style={{ color: "red" }}>{errors.razaoSocial}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">CPF/CNPJ: *</div>
          <input name="cpfCnpj" value={form.cpfCnpj} onChange={handleChange} />
          {errors.cpfCnpj && <span style={{ color: "red" }}>{errors.cpfCnpj}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Inscrição Estadual:</div>
          <input name="inscricaoEstadual" value={form.inscricaoEstadual} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Inscrição Municipal:</div>
          <input name="inscricaoMunicipal" value={form.inscricaoMunicipal} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">E-mail: *</div>
          <input name="email1" value={form.email1} onChange={handleChange} />
          {errors.email1 && <span style={{ color: "red" }}>{errors.email1}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Confirmar E-mail:</div>
          <input name="email2" value={form.email2} onChange={handleChange} />
          {errors.email2 && <span style={{ color: "red" }}>{errors.email2}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Telefone 1: *</div>
          <input name="telefone1" value={form.telefone1} onChange={handleChange} />
          {errors.telefone1 && <span style={{ color: "red" }}>{errors.telefone1}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Telefone 2:</div>
          <input name="telefone2" value={form.telefone2} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Telefone 3:</div>
          <input name="telefone3" value={form.telefone3} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Site:</div>
          <input name="site" value={form.site} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento-cep">
          <div className="Form-Interno-label">CEP:</div>

            <div style={{ display: "flex", gap: "10px", flexDirection: "row" }}>
              <input
                name="cep"
                value={form.cep}
                onChange={handleChange}
                maxLength={9}
                placeholder="00000-000"
                className="cep"
              />

              <button type="button" onClick={buscarCep} disabled={buscandoCep}>
                {buscandoCep ? "Buscando..." : "Buscar"}
              </button>
            </div>
          </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Rua:</div>
            <input name="rua" value={form.rua} onChange={handleChange} />
          </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Número:</div>
            <input name="numero" value={form.numero} onChange={handleChange} />
          </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Bairro:</div>
            <input name="bairro" value={form.bairro} onChange={handleChange} />
          </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Complemento:</div>
            <input name="complemento" value={form.complemento} onChange={handleChange} />
          </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Cidade:</div>
            <input name="cidade" value={form.cidade} onChange={handleChange} />
          </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">UF:</div>
            <input name="uf" maxLength={2} value={form.uf} onChange={handleChange} />
          </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">SMTP Host:</div>
          <input name="smtpHost" value={form.smtpHost} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">SMTP Port:</div>
          <input name="smtpPort" value={form.smtpPort} onChange={handleChange} />
          {errors.smtpPort && <span style={{ color: "red" }}>{errors.smtpPort}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">SMTP Username:</div>
          <input name="smtpUsername" value={form.smtpUsername} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">SMTP Password:</div>
          <input type="password" name="smtpPassword" value={form.smtpPassword} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">SMTP Protocol:</div>
          <input name="smtpProtocol" value={form.smtpProtocol} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Email Remetente:</div>
          <input name="emailRemetente" value={form.emailRemetente} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome Remetente:</div>
          <input name="nomeRemetente" value={form.nomeRemetente} onChange={handleChange} />
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Status:</div>
          <select name="ativo" value={String(form.ativo)} onChange={handleChange}>
            <option value="true">Ativo</option>
            <option value="false">Inativo</option>
          </select>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">SMTP Auth:</div>
          <input type="checkbox" className="checkbox" name="smtpAuth" checked={form.smtpAuth} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">SMTP STARTTLS:</div>
          <input type="checkbox" className="checkbox" name="smtpStarttls" checked={form.smtpStarttls} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Configurado:</div>
          <input type="checkbox" className="checkbox" name="configurado" checked={form.configurado} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : modo === "novo" ? "Cadastrar" : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
